import { render } from "./ModalAddHours.vue?vue&type=template&id=b238a846&scoped=true"
import script from "./ModalAddHours.vue?vue&type=script&lang=js"
export * from "./ModalAddHours.vue?vue&type=script&lang=js"

import "./ModalAddHours.vue?vue&type=style&index=0&id=b238a846&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b238a846"]])

export default __exports__